import { Avatar, Box, Button, Divider, Grid, IconButton, Typography } from "@mui/material"
import { useEffect, useState } from "react";

import NorthEastIcon from '@mui/icons-material/NorthEast';
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import OrderServices from "../../../../api/orderServices/order.index";


const UserDetail = () => {
    const [stats, setStats] = useState(null)
    const navigate = useNavigate()

    const { id } = useParams()

    const getData = async () => {
        try {
            let params = {
                customer_id: id,

            };

            const data = await OrderServices.getUserStats(params);

         console.log(data);
         

            setStats(data?.data)


        } catch (error) {
            console.error("Error fetching location:", error);
        }
    };
    const line1Cards = [
        {
            name: "Total Generations",
            totalnumber: stats?.generationsTotal,
            tenure: "This Month",
            currentMonthTotal: stats?.generationsThisMonth,
            lastTenure: "Last Month",
            lastMonthTotal: stats?.generationsLastMonth,
            background: "#18a5c3",
        },
        {
            name: "Total Designs",
            totalnumber: stats?.designsTotal,
            tenure: "This Month",
            currentMonthTotal: stats?.designsThisMonth,
            lastTenure: "Last Month",
            lastMonthTotal: stats?.designsLastMonth,
            background: "#191d31",
        },
   
    ];

    useEffect(() => {
        getData()
    }, [])

    return (
        <div style={{ padding: '50px', marginTop: '40px' }}>
            <Box >
                <Typography
                    sx={{
                        fontSize: "28px",
                        fontWeight: 600,
                        fontFamily: "Open Sans",
                        color: "#191d31", // Replace with your actual color value
                    }}
                >
                    User Statistics

                </Typography>
            </Box>
            <Grid item xs={12} md={10}>
                <Typography
                    sx={{
                        fontSize: {  md: "18px" },
                        fontWeight: 700,
                        mt:4,
                      
                        fontFamily: "Maven Pro, sans-serif",
                        color: "#0f172a",
                    }}
                >
                    Last Active : {stats?.lastActiveDate ? moment(stats?.lastActiveDate).format('DD-MM-YYYY') : ''}
                </Typography>
            </Grid>
            
            <Grid container spacing={2} mt={2} >
                {line1Cards?.map((card, index) => (
                    <Grid
                        item
                        xs={12}  // This makes each card take full width on smaller screens
                        sm={4}   // This makes each card take 3 columns on medium screens
                        md={4}   // This keeps 3 cards in a row on large screens
                        key={index}
                        sx={{

                            padding: "15px 0px" // Custom width for each screen size
                        }}
                    >
                        <Box
                            sx={{
                                backgroundColor: card.background,
                                padding: 3,
                                borderRadius: 2,
                                textAlign: 'center',
                                height: '100px',
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}>
                                <Typography variant="h6" sx={{ color: "#fff" }}>
                                    {card.name}
                                </Typography>
                                <Typography variant="body1" sx={{ color: "#fff" }}>
                                    {card.totalnumber}
                                </Typography>
                            </Box>
                            <Divider sx={{ my: "12px", borderColor: "#363638" }} />
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        gap: "3px"
                                    }}>
                                    <Typography variant="h6" sx={{ color: "#fff", fontSize: '12px', fontWeight: '600px' }}>
                                        {card.tenure} :
                                    </Typography>
                                    <Typography variant="body1" sx={{ color: "#fff", fontSize: '10px', fontWeight: '600px' }}>
                                        {card.currentMonthTotal}
                                    </Typography>
                                </Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        gap: "3px"
                                    }}>
                                    <Typography variant="h6" sx={{ color: "#fff", fontSize: '12px', fontWeight: '600px' }}>
                                        {card.lastTenure} :
                                    </Typography>
                                    <Typography variant="body1" sx={{ color: "#fff", fontSize: '10px', fontWeight: '600px' }}>
                                        {card.lastMonthTotal}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>
            <Grid item xs={12} md={10}>
                <Typography
                    sx={{
                        fontSize: {  md: "18px" },
                        fontWeight: 700,
                        mt:4,
                      
                        fontFamily: "Maven Pro, sans-serif",
                        color: "#0f172a",
                    }}
                >
                    Last Generation 
                </Typography>
            </Grid>
            {stats?.lastImage ? <Grid container xs={12}  spacing={3} sx={{ border: "1px solid #ddd", borderRadius: 2, margin: '0 auto', p: 2,mt:4 }}>

                
                <Grid item xs={6}>
                    <Typography variant="body1">
                        <strong>Date:</strong> {moment(stats?.lastImage?.created_at).format('DD-MM-YYYY')}
                    </Typography>
                </Grid>
               

            

             

                <Grid item xs={6}>
                    <Typography variant="body1">
                        <strong>Prompt:</strong> {stats?.lastImage?.prompt}
                    </Typography>
                </Grid>
                <Grid item xs={6}>
                <strong>Picture:</strong> 
                    <Typography variant="body1">
                        
                        <Box component={'img'} src={stats?.lastImage?.url} width={'200px'}>

                        </Box>
                    </Typography>
                </Grid>
               

            </Grid> : 'No Generation'}
           

        </div>
    )
}

export default UserDetail
